module.exports = __webpack_public_path__ + "static/media/home-main.1aed08b3.svg";